export default __webpack_public_path__ + "static/media/bcit_logo.2622a5f6.svg";